import { render, staticRenderFns } from "./Years.vue?vue&type=template&id=04a4fa30&scoped=true"
import script from "./Years.vue?vue&type=script&lang=js"
export * from "./Years.vue?vue&type=script&lang=js"
import style0 from "./Years.vue?vue&type=style&index=0&id=04a4fa30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a4fa30",
  null
  
)

export default component.exports